import React, { useEffect, useState } from "react";

import CashoutPanel from "../cashoutPanel/cashoutPanel.component";
import useAppContext from "../../../hooks/useAppContext";

import { StyledWrapper } from "./cashoutsLayout.style";

const CashoutsLayout = () => {
  const { axios } = useAppContext();
  const [balance, setBalance] = useState(null);
  const [count, setCount] = useState(null);
  const [items, setItems] = useState(null);
  const [total, setTotal] = useState(null);

  const updateBalance = () => {
    axios
      .get("/admin/solvers/cashouts/balance")
      .then((res) => {
        setBalance(
          isFinite(res.data.data)
            ? Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(res.data.data)
            : null,
        );
      })
      .catch((err) => {
        setBalance(null);
        console.error(err);
      });
  };

  const updateItems = () => {
    axios
      .get("/admin/solvers/cashouts")
      .then((res) => {
        setCount(res.data.data.count);
        setItems(res.data.data.cashouts);
        setTotal(
          isFinite(res.data.data.total)
            ? Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(res.data.data.total)
            : null,
        );
      })
      .catch((err) => {
        setCount(null);
        setItems(null);
        setTotal(null);
        console.error(err);
      });
  };

  useEffect(() => {
    updateBalance();
    updateItems();
  }, []);

  return (
    <StyledWrapper>
      <div className="cashout-heading">
        <h1>
          Manage PayPal Cashouts {count || count === 0 ? `(${count})` : ""}
        </h1>
        <div className="cashout-details">
          <div>
            Current PayPal Balance: <span className="value">{balance}</span>
          </div>
          <div>
            Current Cashout Total: <span className="value">{total}</span>
          </div>
        </div>
      </div>
      <div className="cashout-items">
        {items &&
          items.map((item, index) => (
            <CashoutPanel cashout={item} key={index} />
          ))}
      </div>
    </StyledWrapper>
  );
};

export default CashoutsLayout;
